'use strict';

require('./sass/application.scss');

// Add Import/Require lines for additional modules, including KendoUI, etc...
// See doc/client.md for more details and examples!

// const SupportUI = require('./js/support-ui.js')
// const TestsUI = require('./js/tests-ui.js')
var LoginUI = require('./js/login-ui'); // This is the main entry point for webpack.
// It should include the main resources to be webpack-ed, specific to this application.

// Application custom style

var ChangePwdUI = require('./js/change-pwd-ui');
var LogoutUI = require('./js/logout-ui');

module.exports = exports = {
   // Modules to expose to the application pages
   LoginUI: LoginUI, LogoutUI: LogoutUI, ChangePwdUI: ChangePwdUI
};


//////////////////
// WEBPACK FOOTER
// ./client/main.js
// module id = 132
// module chunks = 0